import React from "react";
import "./workCard.css";

import { Building, Date, Location } from "../../Portfolio Asset/exportAsset";

const WorkCard = ({ title, btn, company, location, date }) => {
  return (
    <div className="app__workCard">
      <div className="app__workCard-top">
        <h1 className="app__workCard-title-h1">{title}</h1>

        <div className="app__workCard-right">
          <button type="button">{btn}</button>
        </div>
      </div>

      <div className="app__workCard-bottom">
        <div className="app__workCard-location">
          <div className="app__workCard-location-left">
            <img src={Building} alt="Building" />
            <p className="app__workCard-p">{company}</p>

            <img src={Location} alt="Building" />
            <p className="app__workCard-p">{location}</p>
          </div>
        </div>

        <div className="app__workCard-right-date">
          <img src={Date} alt="Building" />
          <p className="app__workCard-date">{date}</p>
        </div>
      </div>

      <div className="app__subline">
        <div className="app__subfooter-border"></div>
      </div>
    </div>
  );
};

export default WorkCard;
